/* Domingo de Casa · interacción: cabecera y menú, revelado, cuenta atrás, el sol del domingo y añadir rápido. */
(() => {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  /* Revelado escalonado al aparecer en pantalla */
  const setupReveal = () => {
    const items = document.querySelectorAll('[data-dc-reveal]:not(.is-in)');
    if (!items.length || !('IntersectionObserver' in window) || reduce) return;
    root.classList.add('dc-ready');
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    let last = null, n = 0;
    for (const el of items) {
      n = el.parentElement === last ? n + 1 : 0;
      last = el.parentElement;
      el.style.setProperty('--dc-delay', `${Math.min(n, 5) * 60}ms`);
      io.observe(el);
    }
    requestAnimationFrame(() => {
      for (const el of items) { const r = el.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) el.classList.add('is-in'); }
    });
  };

  /* Cuenta atrás al domingo (hora de Madrid) */
  const setupCountdown = () => {
    let day;
    try { day = new Intl.DateTimeFormat('en-GB', { weekday: 'short', timeZone: 'Europe/Madrid' }).format(new Date()); }
    catch (e) { day = DAYS[new Date().getDay()]; }
    const idx = DAYS.indexOf(day);
    for (const el of document.querySelectorAll('[data-dc-countdown]')) {
      const out = el.querySelector('[data-dc-countdown-text]');
      if (!out) continue;
      if (idx === 0) out.textContent = el.dataset.sunday;
      else if (idx === 6) out.textContent = el.dataset.saturday;
      else if (idx > 0) out.textContent = (el.dataset.other || '').replace('[n]', String(7 - idx));
    }
  };

  /* Cabecera: avisos que rotan, menú lateral, se esconde al bajar y aparece al subir */
  const setupHeader = () => {
    const hdr = document.querySelector('[data-dc-header]');
    if (!hdr) return;
    const items = [...hdr.querySelectorAll('.dc-hdr__ann-item')];
    if (items.length > 1 && !reduce) {
      let i = Math.max(0, items.findIndex((x) => x.classList.contains('is-on')));
      setInterval(() => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 4200);
    }
    const menu = hdr.querySelector('#DcMenu');
    const opener = hdr.querySelector('[data-dc-open-menu]');
    if (menu && opener && typeof menu.showModal === 'function') {
      opener.addEventListener('click', () => { menu.showModal(); opener.setAttribute('aria-expanded', 'true'); });
      menu.addEventListener('close', () => { opener.setAttribute('aria-expanded', 'false'); opener.focus(); });
      menu.querySelector('[data-dc-close-menu]')?.addEventListener('click', () => menu.close());
      menu.addEventListener('click', (e) => { if (e.target === menu) menu.close(); });
    }
    const search = hdr.querySelector('.dc-hdr__search');
    search?.addEventListener('toggle', () => { if (search.open) search.querySelector('input[type=search]')?.focus(); });
    document.addEventListener('click', (e) => { if (search?.open && !search.contains(e.target)) search.open = false; });
    const group = document.getElementById('header-group');
    let lastY = 0, ticking = false;
    const onScroll = (e) => {
      if (ticking) return; ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        const t = e.target;
        const y = t && t !== document && t.scrollTop !== undefined && t.classList?.contains('page-wrapper') ? t.scrollTop : window.scrollY;
        if (!group) return;
        const hide = y > lastY && y > 160 && !search?.open && !(menu && menu.open);
        group.classList.toggle('dc-hdr-hide', hide);
        lastY = y;
      });
    };
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  };

  /* Tu domingo: el sol recorre el arco según la tarjeta que se ve (móvil) o que se señala (escritorio) */
  const setupDay = () => {
    for (const day of document.querySelectorAll('[data-dc-day]')) {
      const cards = [...day.querySelectorAll('[data-dc-day-panel]')];
      const clock = day.querySelector('[data-dc-clock]');
      const sky = day.querySelector('.dc-day__sky');
      const sun = day.querySelector('.dc-day__sun');
      const track = day.querySelector('[data-dc-day-track]');
      if (!cards.length || !sky || !sun) continue;
      const setSun = (hour) => {
        const w = sky.clientWidth, h = sky.clientHeight, s = sun.getBoundingClientRect().width || 24;
        const t = Math.min(1, Math.max(0, (hour - 7) / 15));
        day.style.setProperty('--dc-sun-x', `${(t * (w - s)).toFixed(1)}px`);
        day.style.setProperty('--dc-sun-y', `${((h - s) * (1 - Math.sin(t * Math.PI))).toFixed(1)}px`);
        day.style.setProperty('--dc-sun-r', `${Math.round(t * 240)}deg`);
      };
      const activate = (c) => { if (clock && c.dataset.time) clock.textContent = c.dataset.time; setSun(Number(c.dataset.hour || 12)); };
      activate(cards[0]);
      for (const c of cards) {
        c.addEventListener('mouseenter', () => activate(c));
        c.addEventListener('focusin', () => activate(c));
      }
      if (track && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          for (const e of entries) if (e.isIntersecting && getComputedStyle(track).overflowX !== 'visible') activate(e.target);
        }, { root: track, threshold: 0.6 });
        cards.forEach((c) => io.observe(c));
      }
    }
  };

  /* Carruseles: flechas, puntos y el punto activo según la diapositiva que se ve */
  const setupCarousels = () => {
    for (const box of document.querySelectorAll('[data-dc-carousel]:not([data-dc-ok])')) {
      box.setAttribute('data-dc-ok', '');
      const track = box.querySelector('[data-dc-track]');
      const slides = [...box.querySelectorAll('[data-dc-slide]')];
      const dots = [...box.querySelectorAll('[data-dc-dot]')];
      const prev = box.querySelector('[data-dc-prev]');
      const next = box.querySelector('[data-dc-next]');
      if (!track || slides.length < 2) continue;
      let current = 0;
      const go = (i) => {
        const s = slides[Math.max(0, Math.min(slides.length - 1, i))];
        const pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
        track.scrollTo({ left: s.offsetLeft - track.offsetLeft - pad, behavior: reduce ? 'auto' : 'smooth' });
      };
      const paint = () => {
        dots.forEach((d, i) => d.classList.toggle('is-on', i === current));
        if (prev) prev.disabled = current === 0;
        if (next) next.disabled = current === slides.length - 1;
      };
      prev?.addEventListener('click', () => go(current - 1));
      next?.addEventListener('click', () => go(current + 1));
      dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          for (const e of entries) if (e.isIntersecting) { current = slides.indexOf(e.target); paint(); }
        }, { root: track, threshold: 0.6 });
        slides.forEach((s) => io.observe(s));
      }
      paint();
    }
  };

  /* Añadir rápido a la cesta */
  const toast = (() => {
    let el, timer;
    return (text) => {
      if (!el) {
        el = document.createElement('div');
        el.className = 'dc dc-toast';
        el.setAttribute('role', 'status');
        el.innerHTML = '<span></span><a href="/cart">Ver cesta</a>';
        document.body.appendChild(el);
      }
      el.querySelector('span').textContent = text;
      requestAnimationFrame(() => el.classList.add('is-on'));
      clearTimeout(timer);
      timer = setTimeout(() => el.classList.remove('is-on'), 4200);
    };
  })();
  const updateCount = async () => {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      for (const c of document.querySelectorAll('[data-dc-cart-count]')) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; }
      for (const a of document.querySelectorAll('[data-dc-cart-link]')) a.setAttribute('aria-label', `Cesta, ${cart.item_count} productos`);
    } catch (e) { /* sin conexión: no pasa nada */ }
  };
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-dc-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.dcAdd), quantity: 1 }] }) });
      if (!res.ok) { const err = await res.json().catch(() => ({})); toast(err.description || 'No se ha podido añadir. Inténtalo de nuevo.'); return; }
      toast(`Añadido: ${btn.dataset.dcTitle || 'producto'}`);
      const pick = btn.closest('details'); if (pick) pick.open = false;
      const main = btn.closest('.dc-qa')?.querySelector('.dc-qa__btn');
      main?.classList.add('is-done'); setTimeout(() => main?.classList.remove('is-done'), 1600);
      updateCount();
      document.dispatchEvent(new CustomEvent('dc:cart-added'));
    } catch (err) {
      toast('No se ha podido añadir. Inténtalo de nuevo.');
    } finally { btn.disabled = false; }
  });
  // Formularios de producto de la home (favoritos): añadir sin salir de la página
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.dc-spot__form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!res.ok) { const err = await res.json().catch(() => ({})); toast(err.description || 'No se ha podido añadir. Inténtalo de nuevo.'); return; }
      const sel = form.querySelector('select');
      const size = sel ? ` · ${sel.options[sel.selectedIndex].text.split(' · ')[0]}` : '';
      toast(`Añadido: ${btn?.dataset.dcTitle || 'producto'}${size}`);
      updateCount();
      document.dispatchEvent(new CustomEvent('dc:cart-added'));
    } catch (err) {
      toast('No se ha podido añadir. Inténtalo de nuevo.');
    } finally { if (btn) btn.disabled = false; }
  });

  // Cerrar el selector de medida al tocar fuera
  document.addEventListener('click', (e) => {
    for (const d of document.querySelectorAll('.dc-qa__pick[open]')) if (!d.contains(e.target)) d.open = false;
  });

  const init = () => { setupCountdown(); setupHeader(); setupReveal(); setupDay(); setupCarousels(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', () => { setupCountdown(); setupReveal(); setupDay(); setupCarousels(); });
})();
